export default "__VITE_ASSET__897ccf7c__"